import { reservationService } from '../../services';

interface IConfig {
  getCoverageReport: (params: any) => Promise<any>;
  downloadCoverageReport: (params: any) => Promise<any>;
  getSummaryReport: (params: any) => Promise<any>;
  downloadSummaryReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getCoverageReport: (params: any) => reservationService.getCoverageReport(params),
  downloadCoverageReport: (params: any) =>
    reservationService.downloadCoverageReport(params),
  getSummaryReport: (params: any) => reservationService.getSummaryReport(params),
  downloadSummaryReport: (params: any) =>
    reservationService.downloadSummaryReport(params),
};
